import type {
    GetCommerceOrderRequest,
    GetCommerceOrderResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const getCommerceOrderOperation = defineCommerceOperation<
    GetCommerceOrderRequest,
    GetCommerceOrderResponse
>("commerce.orders.get");
